import React, { Component } from 'react'
import Row from 'components/common/row'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import TextField from 'components/ui/text-field'
import ContactCard from '../contact-card'
import ContactNote from './note'
type Props = {
  contact: Record<string, any>
  addContactNote: (...args: Array<any>) => any
  deleteContactNote: (...args: Array<any>) => any
  updateContactNote: (...args: Array<any>) => any
}
type State = {
  adding: boolean
  showNewNote: boolean
}

class NotesTab extends Component<Props, State> {
  state: State = {
    showNewNote: false,
    adding: false,
  }
  _newNoteText: any
  // TODO: Optimistic updates can improve user experience (1)
  _onAddNote: () => void = () => {
    const { value } = this._newNoteText
    if (!value) return
    this.setState({
      adding: true,
    })
    this.props
      .addContactNote(this.props.contact.id, value)
      .then(() => {
        this.setState({
          adding: false,
          showNewNote: false,
        })
      })
      .catch(() =>
        this.setState({
          adding: false,
        }),
      )
  }
  _hideNewNote: () => void = () =>
    this.setState({
      showNewNote: false,
    })
  _showNewNote: () => void = () =>
    this.setState({
      showNewNote: true,
    })
  // TODO: Optimistic updates can improve user experience (2)
  _onUpdateNote: (contactId: number, noteId: number, text: string) => any = (
    contactId: number,
    noteId: number,
    text: string,
  ) => {
    return this.props
      .updateContactNote(contactId, noteId, text)
      .then(() =>
        this.setState({
          showNewNote: true,
        }),
      )
      .catch(() =>
        this.setState({
          showNewNote: true,
        }),
      )
  }

  render(): React.ReactNode {
    const { notes } = this.props.contact
    return (
      <React.Fragment>
        {notes &&
          notes.map(note => (
            <ContactNote
              key={note.id}
              note={note}
              onDelete={() =>
                this.props.deleteContactNote(this.props.contact.id, note.id)
              }
              onUpdate={text =>
                this._onUpdateNote(this.props.contact.id, note.id, text)
              }
              onEdit={this._hideNewNote}
              onCancelEdit={this._showNewNote}
            />
          ))}
        {this.state.showNewNote ? (
          <ContactCard>
            <Row columnsSize={[12]} marginBottom>
              <div>
                <TextField
                  label="Add new note"
                  inputRef={r => {
                    this._newNoteText = r
                  }}
                  multiline
                />
              </div>
            </Row>
            <ButtonContainer>
              <Button
                appearance="primary"
                caption="Save note"
                progressCaption="Saving note"
                progressIndicator={this.state.adding}
                onClick={this._onAddNote}
              />
              <Button caption="Cancel" onClick={this._hideNewNote} />
            </ButtonContainer>
          </ContactCard>
        ) : (
          <ContactCard
            action={{
              content: 'Add a note',
              onClick: this._showNewNote,
            }}
          >
            Add new note
          </ContactCard>
        )}
      </React.Fragment>
    )
  }
}

export default NotesTab
